import { Link } from 'react-router';

export default function AVVPage() {
  return (
    <main className="min-h-screen bg-warm-50 px-6 py-16 lg:px-8">
      <div className="mx-auto max-w-3xl rounded-2xl border border-warm-200/60 bg-white p-8 lg:p-10 shadow-[0_10px_28px_-16px_rgba(26,24,22,0.18)]">
        <h1 className="text-3xl font-semibold tracking-tight text-warm-800 mb-4">AVV / DPA</h1>
        <p className="text-warm-600 leading-relaxed mb-6">
          Für Auftragsverarbeitung stellen wir eine AVV zur Verfügung.
          Bitte kontaktieren Sie uns für die aktuelle Fassung und Gegenzeichnung.
        </p>
        <section id="avv-anfordern" className="mb-6 scroll-mt-24">
          <h2 className="text-xl font-semibold text-warm-800 mb-2">AVV anfordern</h2>
          <p className="text-warm-600 leading-relaxed">
            Diese oeffentliche Seite ist die Landing-Zieladresse fuer den AVV-Hinweis. Sie beschreibt den
            Anfrageweg, die Gegenzeichnung und den Support-Kanal fuer bestehende oder pruefende Einrichtungen.
          </p>
        </section>
        <a href="mailto:support@getflowly.de?subject=AVV%20Anfrage" className="landing-cta-primary mr-3">AVV anfragen</a>
        <Link to="/" className="landing-cta-secondary">Zur Landing Page</Link>
      </div>
    </main>
  );
}
